import React from 'react';
import classNames from 'classnames';
import "./_customDogIcon.scss";

// SVG Imports
import {ReactComponent as SuccessDog} from '../images/DogIconographySvgs/SuccessDog.svg';
import {ReactComponent as ErrorDog} from '../images/DogIconographySvgs/ErrorDog.svg';

export const DogColors = {
    default: "",
    rainbow: "important-dog-business__rainbow",
    danger: "important-dog-business__danger",
    warn: "important-dog-business__warn",
    primary: "important-dog-business__primary",
    neutral: "important-dog-business__neutral"
}

export const DogIcon = {
    SuccessDog: SuccessDog,
    ErrorDog: ErrorDog
}

export const CustomDogIcon = ({IconType, dogColor = DogColors.default, className, ...props}) => {
    return (
        <IconType className={classNames("important-dog-business", dogColor, className)} {...props}/>
    );
}

export default CustomDogIcon;
